import {
  IElementType,
  IExtendElementType,
  IReferenceElement,
} from "../definitions/element";
import { orderBy } from "lodash";
import { alphabet } from "../untils/const";
import { IAddtionalElements } from "../definitions/additional";
import { generatePoint, getElement } from "../components/Section/sectionModel";
import { ListSectionProps } from "../types/sectionTypes";
import { IJointType } from "../definitions/joint";
import { ISpoolCanvas, ISpoolElement } from "../definitions/spools";
import { IProject } from "../store/interface/projects";
import { UserContract, UserContractSimple } from "../store/interface/user";

export const veryfiedMoveCordinates = (
  value: number,
  max: number,
  min: number
): number => {
  let result = value;
  if (value < min) {
    result = min;
  } else if (value > max) {
    result = max;
  }
  return result || 0;
};

export const getPoints = (
  elements: IElementType[],
  references: IReferenceElement[],
  sectionID: string,
  pageNumber?: number
) => {
  if (elements.length === 0) {
    return elements;
  }
  const filtered = elements.filter(
    (element) =>
      (pageNumber === undefined || element.page === pageNumber) &&
      element.sectionID === sectionID
  );
  if (references.length > 0) {
    const filteredReference = references.filter(
      (element) =>
        element.page === pageNumber && element.sectionID === sectionID
    );
    filteredReference.forEach((ref) => {
      const sourceElement = getElement(ref.sourceElementID, elements);
      filtered.push({
        ...sourceElement,
        ...ref,
      });
    });
  }
  return filtered;
};

export const getSpoolsForCanvas = (
  spools: ISpoolElement[],
  sectionID: string,
  pageNumber?: number
): ISpoolCanvas[] => {
  const filtered: ISpoolCanvas[] = [];
  if (spools.length > 0) {
    spools.forEach((_spool) => {
      if (_spool.instances.length > 0) {
        _spool.instances.forEach((_instance) => {
          if (
            _instance.sectionID === sectionID &&
            _instance.page === pageNumber
          ) {
            filtered.push({
              ..._instance,
              spoolID: _spool.spoolID,
              spoolName: _spool.spoolName,
            });
          }
        });
      }
    });
  }
  return filtered;
};

//ToDo unit test ---!!!!
export const getPointsForList = (
  elements: IElementType[],
  sectionID: string,
  references: IReferenceElement[],
  showJointWeld: boolean
) => {
  const filtered = elements.filter(
    (element) => element.sectionID === sectionID
  );

  if (showJointWeld && references.length > 0) {
    const filteredReference = references.filter(
      (ref) => ref.sectionID === sectionID
    );

    filteredReference.forEach((ref) => {
      const sourceElement = getElement(ref.sourceElementID, elements);
      // Ensure we only add the sourceElement if it exists
      if (sourceElement) {
        filtered.push({
          ...sourceElement,
          ...ref,
          marked: true,
        });
      }
    });
  }

  return filtered;
};

export const getPointsForListWithKKS = (
  elements: IElementType[],
  sectionID: string,
  references: IReferenceElement[],
  sections: ListSectionProps[],
  projectID: string,
  projects: IProject[],
  contracts: UserContractSimple[]
) => {
  const points: IExtendElementType[] = [];
  const filtered = getPointsForList(elements, sectionID, references, false);

  filtered.forEach((_item) => {
    const sectionDetails = sections.find(
      (section) => section.sectionID === _item.sectionID
    );
    const projecDetails = projects.find(
      (_project) => _project.projectID === projectID
    );
    const contractDetails = contracts.find(
      (_contract) => _contract.contractID === projecDetails?.contractID
    );

    if (sectionDetails && projecDetails && contractDetails) {
      points.push(
        generatePoint(
          _item as IJointType,
          sectionDetails,
          projecDetails,
          contractDetails
        )
      );
    }
  });
  return points;
};

//ToDo unit test ---!!!!
export const getMapElementForPage = (
  elements: IAddtionalElements[],
  pageNumber: number,
  sectionID: string
) => {
  if (elements === undefined) {
    return elements;
  }
  return elements.filter(
    (element) => element.page === pageNumber && element.sectionID === sectionID
  );
};

export const calculateCoordinates = (
  x: number,
  y: number,
  asc: boolean = false
): number => {
  if (asc) {
    return x <= y ? x : y;
  }
  return x <= y ? y : x;
};

export interface ICord {
  min: number;
  max: number;
}

export const getCordinates = (pointCord: number, labelCord: number): ICord => {
  const pointStart = pointCord - 2;
  const pointEnd = pointCord + 2;
  const labelStart = pointCord + labelCord - 25;
  const labelEnd = pointCord + labelCord + 25;
  return {
    min: calculateCoordinates(pointStart, labelStart, true),
    max: calculateCoordinates(pointEnd, labelEnd),
  };
};

export interface IPointArea {
  topMin: number;
  topMax: number;
  leftMin: number;
  leftMax: number;
}
export const getPointsArea = (
  pointTop: number,
  pointLeft: number,
  labelTop: number,
  labelLeft: number
): IPointArea => {
  const topCord: ICord = getCordinates(pointTop, labelTop);
  const leftCord: ICord = getCordinates(pointLeft, labelLeft);
  const PointArea: IPointArea = {
    topMin: topCord.min,
    topMax: topCord.max,
    leftMin: leftCord.min,
    leftMax: leftCord.max,
  };
  return PointArea;
};

interface IValidatePosition {
  top: number;
  left: number;
}

//ToDo unit test ---!!!!
export const validatePosition = (
  pointTop: number,
  pointLeft: number,
  labelTop: number,
  labelLeft: number,
  targetTopMin: number,
  targetTopMax: number,
  targetLeftMin: number,
  targetLeftMax: number,
  pointMode: boolean
): IValidatePosition => {
  const pointArea = getPointsArea(pointTop, pointLeft, labelTop, labelLeft);
  let validateTop = pointMode ? pointTop : labelTop;
  let validateLeft = pointMode ? pointLeft : labelLeft;
  const deltaTop = validateCoordinates(
    pointArea.topMin,
    pointArea.topMax,
    targetTopMin,
    targetTopMax
  );
  const deltaLeft = validateCoordinates(
    pointArea.leftMin,
    pointArea.leftMax,
    targetLeftMin,
    targetLeftMax
  );
  if (deltaTop.min !== 0) {
    validateTop = validateTop + deltaTop.min;
  }
  if (deltaTop.max !== 0) {
    validateTop = validateTop - deltaTop.max;
  }
  if (deltaLeft.min !== 0) {
    validateLeft = validateLeft + deltaLeft.min;
  }
  if (deltaLeft.max !== 0) {
    validateLeft = validateLeft - deltaLeft.max;
  }
  return {
    top: validateTop,
    left: validateLeft,
  };
};

interface ICordinatesValidator {
  min: number;
  max: number;
}

//ToDo unit test ---!!!!
export const validateCoordinates = (
  moveMin: number,
  moveMax: number,
  targetMin: number,
  targetMax: number
): ICordinatesValidator => {
  const validators: ICordinatesValidator = {
    min: moveMin < targetMin ? Math.abs(targetMin - moveMin) : 0,
    max: moveMax > targetMax ? Math.abs(moveMax - targetMax) : 0,
  };

  return validators;
};

export const checkNumberName = (
  suffix: string,
  suffixArray: string[],
  number: number
): string => {
  const suffixLength = suffix.length;
  let numberCheck = number.toString().padStart(suffixLength, "0");

  if (suffixArray.includes(numberCheck)) {
    return checkNumberName(suffix, suffixArray, number + 1);
  }
  return numberCheck;
};

//ToDo unit test ---!!!!
export const checkCharName = (
  suffix: string,
  suffixArray: string[],
  char: string
): string => {
  if (!suffixArray.includes(char)) {
    return char;
  }
  const charIndex = alphabet.findIndex((item) => item === char);
  if (charIndex !== alphabet.length - 1) {
    const nextChar = alphabet[charIndex + 1];
    return checkCharName(suffix, suffixArray, nextChar);
  }

  return "";
};

export const lettersToNumber = (s: string): number => {
  let n = 0;
  for (let i = 0; i < s.length; i++) {
    n = n * 26 + (s.toLowerCase().charCodeAt(i) - 97 + 1);
  }
  return n;
};

export const numberToLetters = (n: number): string => {
  let s = "";
  while (n > 0) {
    const mod = (n - 1) % 26;
    s = String.fromCharCode(97 + mod) + s;
    n = Math.floor((n - 1) / 26);
  }
  return s;
};

const isNumeric = (s: string) => /^\d+$/.test(s);
const isAlpha = (s: string) => /^[a-z]+$/i.test(s);
const isAlphaNum = (s: string) => /^[a-z]+\d+$/i.test(s);

export const findGap = (arr: number[]): number => {
  arr = [...arr].sort((a, b) => a - b);
  for (let i = 0; i < arr.length - 1; i++) {
    if (arr[i + 1] - arr[i] > 1) return arr[i] + 1;
  }
  return arr.length > 0 ? arr[arr.length - 1] + 1 : 1;
};

export const setNewSuffix = (suffix: string, scope: string[]): string => {
  if (
    (!suffix && scope.length && scope.every(isAlpha)) ||
    (suffix && isAlpha(suffix))
  ) {
    const nums = scope.filter(isAlpha).map(lettersToNumber);
    if (nums.length === 0) return "a";
    let next = findGap(nums);
    let candidate = numberToLetters(next);
    while (scope.includes(candidate)) {
      next++;
      candidate = numberToLetters(next);
    }
    return candidate;
  }

  if (
    (!suffix && scope.length && scope.every(isNumeric)) ||
    (suffix && isNumeric(suffix))
  ) {
    const nums = scope
      .filter(isNumeric)
      .map((s) => parseInt(s))
      .filter((n) => !isNaN(n));
    const pad = suffix ? suffix.length : scope[0]?.length || 1;
    let next = findGap(nums);
    let candidate = String(next).padStart(pad, "0");
    while (scope.includes(candidate)) {
      next++;
      candidate = String(next).padStart(pad, "0");
    }
    return candidate;
  }

  if (suffix && isAlphaNum(suffix)) {
    const match = suffix.match(/^([a-z]+)(\d+)$/i)!;
    const pre = match[1];
    const numPart = match[2];
    const nums = scope
      .map((s) => {
        const m = s.match(/^([a-z]+)(\d+)$/i);
        return m && m[1] === pre ? parseInt(m[2]) : -1;
      })
      .filter((n) => n > 0);
    let next = findGap(nums);
    let candidate = pre + String(next).padStart(numPart.length, "0");
    while (scope.includes(candidate)) {
      next++;
      candidate = pre + String(next).padStart(numPart.length, "0");
    }
    return candidate;
  }

  const m = suffix.match(/^(\d+)?([a-z]+)?$/i);
  if (m) {
    const numPre = m[1] || "";
    const letPre = m[2] || "";
    if (numPre && letPre) {
      const nums = scope
        .map((s) => {
          const mm = s.match(/^(\d+)([a-z]+)$/i);
          return mm && mm[1] === numPre ? lettersToNumber(mm[2]) : -1;
        })
        .filter((n) => n > 0);
      let next = findGap(nums);
      let candidate = numPre + numberToLetters(next);
      while (scope.includes(candidate)) {
        next++;
        candidate = numPre + numberToLetters(next);
      }
      return candidate;
    }
    if (numPre) {
      const nums = scope
        .map((s) => {
          const mm = s.match(/^(\d+)\.([a-z]+)$/i);
          return mm && mm[1] === numPre ? lettersToNumber(mm[2]) : -1;
        })
        .filter((n) => n > 0);
      if (nums.length) {
        let next = findGap(nums);
        let candidate = numPre + "." + numberToLetters(next);
        while (scope.includes(candidate)) {
          next++;
          candidate = numPre + "." + numberToLetters(next);
        }
        return candidate;
      }
      const nums2 = scope
        .map((s) => {
          const mm = s.match(/^(\d+)$/i);
          return mm ? parseInt(mm[1]) : -1;
        })
        .filter((n) => n > 0);
      if (nums2.length) {
        let next = findGap(nums2);
        let candidate = numPre + "." + String(next);
        while (scope.includes(candidate)) {
          next++;
          candidate = numPre + "." + String(next);
        }
        return candidate;
      }
    }
    if (letPre) {
      const nums = scope.filter(isAlpha).map(lettersToNumber);
      let next = findGap(nums);
      let candidate = numberToLetters(next);
      while (scope.includes(candidate)) {
        next++;
        candidate = numberToLetters(next);
      }
      return candidate;
    }
  }

  return suffix + "1";
};

export const getNamePrefix = (name: string): string => {
  if (name.includes(".")) {
    const parts = name.split(".");
    parts.pop();
    return parts.join(".") + ".";
  }
  const m = name.match(/^[A-Za-z]+/);
  return m ? m[0] : "";
};

export const getScopeForPrefix = (
  names: string[],
  prefix: string
): string[] => {
  return names
    .filter((n) => n.startsWith(prefix))
    .map((n) => n.substring(prefix.length));
};

export const getLastPointName = (points: IElementType[]): string => {
  if (!points.length) return "";
  const sorted = [...points].sort(
    (a, b) =>
      new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime()
  );
  return sorted[sorted.length - 1].joint_name;
};

export const setNewPointName = (
  points: IElementType[],
  sectionID: string,
  ref?: string
): string => {
  const filtered = points.filter((p) => p.sectionID === sectionID);
  if (!filtered.length) return ref || "1";
  const lastName = ref || getLastPointName(filtered);
  if (!lastName) return "1";
  const pointsNames = filtered.map((p) => p.joint_name);
  const splited = lastName.split(".");
  let prePrefix = splited[0];
  if (splited.length > 1) {
    splited.pop();
    if (splited.length > 1) prePrefix = splited.join(".");
  }
  const prefix = lastName.includes(".")
    ? prePrefix + "."
    : getNamePrefix(lastName);
  const suffix = lastName.replace(prefix, "");
  const scope = getScopeForPrefix(pointsNames, prefix);
  return prefix + setNewSuffix(suffix, scope);
};
